export default function DaisyUITest() {
  return (
    <div className="p-8 space-y-4">
      <h1 className="text-3xl font-bold text-base-content">daisyUI Test</h1>
      
      <div className="card bg-base-100 shadow-xl">
        <div className="card-body">
          <h2 className="card-title">Theme Test</h2>
          <p className="text-base-content">This card should change colors with themes</p>
          <div className="card-actions justify-end">
            <button className="btn btn-primary">Primary Button</button>
            <button className="btn btn-secondary">Secondary Button</button>
          </div>
        </div>
      </div>

      <div className="alert alert-info">
        <span>This is an info alert - should adapt to theme</span>
      </div>

      <div className="stats shadow">
        <div className="stat">
          <div className="stat-title">Test Stat</div>
          <div className="stat-value">100</div>
        </div>
      </div>
    </div>
  );
}
